import { doctorBffApi } from '@/modules';
import { QuestionnaireService } from './questionnaire.service';
import {
  AssignedQuestionnaireDto,
  FetchAssignedQuestionnairesParams,
  QuestionnaireInconsistenciesResponse,
  QuestionnaireType
} from './questionnaire.model';
import { wrapError } from '../error';
import { PatientId, WithPatientId } from '@/modules/surgicalEvent';

export const questionnaireApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    assignedQuestionnaires: builder.query<
      AssignedQuestionnaireDto[],
      WithPatientId<FetchAssignedQuestionnairesParams>
    >({
      providesTags: ['Questionnaires'],
      queryFn: ({ patientId, ...params }) =>
        QuestionnaireService.getInstance(patientId)
          .fetchAssignedQuestionnaires(params)
          .catch(wrapError)
    }),

    preopQuestionnaireInconsistencies: builder.query<
      QuestionnaireInconsistenciesResponse,
      PatientId
    >({
      providesTags: ['Questionnaires'],
      queryFn: ({ patientId }) =>
        QuestionnaireService.getInstance(patientId)
          .fetchQuestionnaireInconsistencies(QuestionnaireType.PREOP)
          .catch(wrapError)
    })
  }),
  overrideExisting: false
});

export const {
  usePreopQuestionnaireInconsistenciesQuery,
  useAssignedQuestionnairesQuery
} = questionnaireApi;
